<template>
  <div class="page_content module_person" aria-label="Person Page Content">

    <div class="row page-heading">
      <div class="col-7 input module_heading" role="heading" aria-level="1">
        <div class="module_icon icon-mentor"></div>
        <label class="head_txt module_type_name">{{formattedPerson.prefix}} {{formattedPerson.firstName}} {{formattedPerson.middleName}} {{formattedPerson.lastName}} {{formattedPerson.suffix}}</label>

      </div>
      <div class="col-5 float-right px-0">
        <div class="btn-container">
			<b-btn @click="goToEditPage" class="btn" aria-label="edit" v-if="canEdit">edit</b-btn>
        </div>
      </div>
    </div>

 	<div class="page-content">

         <div class="row section_row">

         	<div class="heading">
	    		<div class="ic"></div>
	    		<div class="hd_txt"><label>Basic Details</label></div>
	    	</div> <!-- heading -->

			<div class="section_content basic_details">

				<div class="person_thumbnail">
					<div class="thumbnail_container">
		           		<div v-if="formattedPerson.thumbnailURI">
							<img class="w-100" id="personThumbnail" :src="formattedPerson.thumbnailURI">
						</div>
	        		    <div v-else class="default">
	        				<div class="thumbnail">
								<div class="ic thumbnail_icon icon-mentor" style="color: #787878;"></div>
							</div>
						</div>
					</div>

					<div class="person_type" tabindex="0">
						<label class="label" for="personType"><!-- Person Type:--> {{formattedPerson.personType}} </label>
					</div>

				</div> <!-- person_thumbnail -->

				<div class="person_details">

					<div class="row details_row">

						<div class="col-5">
		    				<div class="row_title">
		    					<label for="personPhoneNumbers">Phone</label>
		    				</div>

				             <div class="row_value" v-for="number in formattedPerson.contactInfo.phoneList">
				                <span class="row_val_txt" v-if="number && number.type && number.value" tabindex="0">
				                	<span class="txt" :title="number.value">{{number.type}}: {{number.value}}</span>
				                </span>
				                <span class="col_blank empty_pattern" v-else></span>
				            </div>
				            <div class="col_blank empty_pattern" v-if="formattedPerson.contactInfo.phoneList.length == 0"></div>
			            </div>

			            <div class="col-1"></div>

			            <div class="col-5">
			            	<div class="row_title">
		    					<label for="personEmail">Email</label>
		    				</div>

				             <div class="row_value" v-for="email in formattedPerson.contactInfo.eMailList" tabindex="0">
				                <span class="row_val_txt" v-if="email && email.type && email.value">
				                	<span class="txt" :title="email.value">{{email.type}}: {{email.value}}</span>
				                </span>
				            </div>
				            <div class="col_blank empty_pattern" v-if="formattedPerson.contactInfo.eMailList.length == 0"></div>
			            </div>

					</div>


					<div class="row details_row details_second_row">

						<div class="col-5">
		    				<div class="row_title">
		    					<label for="personSocial">Social</label>
		    				</div>

				             <div class="row_value" v-for="social in formattedPerson.contactInfo.socialList">
				                <a class="row_val_txt" v-if="social && social.type && social.value" :href="social.value">
				                	<span class="txt" :title="social.value">{{social.type}}: {{social.value}}</span>
				                </a>
				                <br v-if="social && social.type && social.value">
				            </div>
				             <div class="col_blank empty_pattern" v-if="formattedPerson.contactInfo.socialList.length == 0"></div>
						</div>

						<div class="col-1"></div>

	    				<div class="col-5">
		    				<div class="row_title">
		    					<label for="personWebsite">Website</label>
		    				</div>

				            <div v-for="website in formattedPerson.contactInfo.websiteList">
				            	<a class="row_val_txt" v-if="website && website.value" :href="website.value">
				            		<span class="txt" :title="website.value">{{website.value}}</span>
				            	</a>
				                <br v-if="website && website.value">
				            </div>
				            <div class="col_blank empty_pattern" v-if="formattedPerson.contactInfo.websiteList.length == 0"></div>
						</div>

					</div>


				</div> <!-- person_details -->

			</div> <!-- section_content basic_details -->

		</div> <!-- section_row -->


         	<div class="row section_row" v-if="formattedPerson.biography">
				<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label>Biography</label></div>
		    	</div> <!-- heading -->
				<div class="section_content">
					<div class="courseDesc">
						<div class="desc-content" v-html="formattedPerson.biography" tabindex="0"></div>
					</div>
				</div>
			</div>


			<div class="row section_row" v-if="formattedPerson.areaOfInterestTerms && formattedPerson.areaOfInterestTerms.length && formattedPerson.areaOfInterestTerms.length > 0">
				<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label tabindex="0">Area of Interest</label></div>
		    	</div> <!-- heading -->

				<div class="section_content">
					<div class="tag-section">
						<div class="">
							<div class="icon-container" style="margin-right: 15px; float: left;">
								<span class="icon ic-tag" style="font-size: 32px; color: #787878;"></span>
							</div>
							<div class="tags-row tags_container">
								<span class="tag" v-for="interest in formattedPerson.areaOfInterestTerms" tabindex="0" style="background: #e0f2ff;">
									<span class="tag_name instructional_tag" :title="interest" v-if="interest">{{interest}} </span>
								</span>
							</div>
						</div>
          			</div>
				</div>

			</div>


			 <div class="row section_row" v-if="formattedPerson.experienceInfoList && formattedPerson.experienceInfoList.length && formattedPerson.experienceInfoList.length > 0">
				<div class="heading">
	    		<div class="ic"></div>
	    		<div class="hd_txt"><label tabindex="0">Experience</label></div>
	    	</div> <!-- heading -->
				<div class="section_content">
					<div class="row">
						<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col" v-for="experience in formattedPerson.experienceInfoList">
							<div class="row">
								<div class="col-12 col_txt_row" tabindex="0">
									<span class="title" v-if="experience.title">Title: {{experience.title}}</span>
								</div>

				                <div class="col-12 col_txt_row" v-if="experience.description" tabindex="0">Description: {{experience.description}}</div>

				                <div class="col-12 col_txt_row" v-if="experience.employer" tabindex="0">Employer: {{experience.employer}}</div>

				                <div class="col-12 col_txt_row" v-if="experience.industry" tabindex="0">Industry: {{experience.industry}}</div>

				                <div class="col-12 col_txt_row" v-if="experience.location" tabindex="0">Location: {{experience.location}}</div>

				                <div class="col-12 col_txt_row" v-if="experience.experienceTimeLabel" tabindex="0">Duration: {{experience.experienceTimeLabel}}</div>
			                </div>
						</div>
					</div>
				</div>
			</div>


			 <div class="row section_row" v-if="formattedPerson.educationInfoList && formattedPerson.educationInfoList.length && formattedPerson.educationInfoList.length > 0">
				<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label tabindex="0">Education</label></div>
		    	</div> <!-- heading -->
				<div class="section_content">
					<div class="row">
						<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col" v-for="education in formattedPerson.educationInfoList">
							<div class="row">
								<div class="col-12 col_txt_row" tabindex="0">
									<span class="title" v-if="education.degree && education.classOf" tabindex="0">Degree: {{education.degree}}, Class of {{education.classOf}} </span>
								</div>

				                <div class="col-12 col_txt_row" v-if="education.institution">Institution: {{education.institution}} </div>

				                <div class="col-12 col_txt_row" v-if="education.majorOne" tabindex="0">Major One: {{education.majorOne}}</div>

				                <div class="col-12 col_txt_row" v-if="education.majorTwo" tabindex="0">Major Two: {{education.majorTwo}}</div>

				                <div class="col-12 col_txt_row" v-if="education.educationTimeLabel" tabindex="0">Duration: {{education.educationTimeLabel}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			 <div class="row section_row" v-if="isTagsAvailable">
              	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label>Tags</label></div>
		    	</div> <!-- heading -->

				<div class="section_content">
					<div class="tag-section">
						<div class="tag-container" style="border: none;">
							<div class="icon-container" style="margin-right: 15px; float: left;">
								<span class="icon ic-tag" style="font-size: 32px;"></span>
							</div>
							<div class="tags-row tags_container">
								<template v-for="(values, key, i) in formattedPerson.appliedTagMap">
                                    <span class="tag ace_sec_txt" v-for="(tag, j) in values">
                                        <span class="tag_name instructional_tag">{{tag.name}}</span>
                                    </span>
                                </template>
							</div>
						</div>
          			</div>
				</div>

            </div>


			<div class="row section_row" v-if="formattedPerson.curriculumVitae && formattedPerson.curriculumVitae.uri">
              	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label>Resume</label></div>
		    	</div> <!-- heading -->

				<div class="section_content">
					<a target="_blank" :href="formattedPerson.curriculumVitae.uri" title="Click here to open this resource in a new tab">
		              <span class="icon-new-tab"> {{ formattedPerson.curriculumVitae.fileName }} </span>
		            </a>
				</div>
			</div>

			 <div class="row section_row" v-if="formattedPerson.contactInfo && formattedPerson.contactInfo.addresses && formattedPerson.contactInfo.addresses.length">
			 	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label>Address</label></div>
		    	</div> <!-- heading -->
				<div class="section_content">
					<div class="row">
						<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col" v-for="address in formattedPerson.contactInfo.addresses">
							<div class="row">
								<div class="col-12 col_txt_row" v-if="address && address.type" tabindex="0">
									<span class="title">{{address.type}}</span>
								</div>

								<div class="col-12 col_txt_row" v-if="address && address.streetOne" tabindex="0">Street One: {{address.streetOne}}</div>

				                <div class="col-12 col_txt_row" v-if="address && address.streetTwo" tabindex="0">Street Two: {{address.streetTwo}}</div>

				                <div class="col-12 col_txt_row" v-if="address && address.city" tabindex="0">City: {{address.city}}</div>

				                <div class="col-12 col_txt_row" v-if="address && address.state" tabindex="0">State: {{address.state}}</div>

				                <div class="col-12 col_txt_row" v-if="address && address.country" tabindex="0">Country: {{address.country}}</div>

				                <div class="col-12 col_txt_row" v-if="address && address.zip" tabindex="0">Zip: {{address.zip}}</div>
			                </div>
						</div>
					</div>
				</div>
			</div>

		</div>
		</div>


    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'person-detail',
    props: ['uuid', 'loadDataFromServer'],
    data: () => {
      return {
        userId: {},
        userObj: JSON.parse(localStorage.getItem('userobj')),
        selectedRow: undefined,
        selectedCourse: {},
        showResume: false,
        monthMap: {
          0: 'Jan',
          1: 'Feb',
          2: 'Mar',
          3: 'April',
          4: 'May',
          5: 'June',
          6: 'July',
          7: 'Aug',
          8: 'Sep',
          9: 'Oct',
          10: 'Nov',
          11: 'Dec'
        },
        defaultContactInfo: {
          'addresses': [],
          'eMailList': [],
          'phoneList': [],
          'socialList': [],
          'websiteList': [],
          'contactsList': []
        }
      }
    },
    mounted () {
      this.loadDataForPersonDetail()
    },

    methods: {
      ...mapActions([
        'loadPerson',
        'loadLibrariesForUser'
      ]),
      showAll () {
        this.$root.$emit('bv::show::modal', 'personDesc')
      },
      closeshowAll () {
        this.$root.$emit('bv::hide::modal', 'personDesc')
      },
      goToEditPage () {
        this.$router.push({ name: 'editPerson', params: { uuid: this.uuid } })
      },
      loadDataForPersonDetail () {
        this.loadPerson({ uuid: this.uuid, loadDataFromServer: this.loadDataFromServer })
        this.userId = localStorage.getItem('userid')
        this.loadLibrariesForUser(this.userId)
      },
      buildTimeRangeLabel (from, to) {
        let monthMap = this.monthMap // maps 0 -> Jan, 1 -> Feb, ....
        // string 'from' is guaranteed to be set from the backend, checking in case
        if (!from) {
          return ''
        }

        // create label prefix in human readable date format instead of UTC
        let dateTime = new Date(from)
        let label = monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear() + ' - '

        if (to && to.length && to.length > 0) {
          dateTime = new Date(to)
          label += monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear()
        } else {
          label += 'Present'
        }
        return label
      },
      showResumeClicked () {
        this.showResume = !this.showResume
      }
    },
    computed: {
      ...mapState({
        'person': state => state.person.personObject,
        'learningSpaces': state => state.assessment.learningSpaces,
        'ownerId': state => state.person.personObject.ownerId,
        'owningLibraryId': state => state.person.personObject.owningLibraryId
      }),
      canEdit () {
        if (this.userId === this.person.userId) {
          return true
        } else if (this.userObj && this.userObj.permission && this.userObj.permission.personPermission.write) {
          return true
        }
        return false
      },
      formattedPerson () {
        let formattedPerson = this.person
        if (!formattedPerson) {
          return {}
        }
        let buildTimeRangeLabel = this.buildTimeRangeLabel
        if (formattedPerson.experienceInfoList) {
          formattedPerson.experienceInfoList.forEach(experience => {
            experience.experienceTimeLabel = buildTimeRangeLabel(experience.from, experience.to)
          })
        }
        if (formattedPerson.educationInfoList) {
          formattedPerson.educationInfoList.forEach(education => {
            education.educationTimeLabel = buildTimeRangeLabel(education.from, education.to)
          })
        }
        if (!formattedPerson.contactInfo || !formattedPerson.contactInfo.phoneList) {
          formattedPerson['contactInfo'] = this.defaultContactInfo
        }
        return formattedPerson
      },
      isTagsAvailable () {
        let keys = Object.keys(this.formattedPerson)
        if (keys.length > 0 && keys.includes('appliedTagMap')) {
          let values = Object.values(this.formattedPerson.appliedTagMap)
          return values.find((value) => {
            return value.length > 0
          })
        }
        return false
      }
    }
  }
</script>

<style scoped>
.heading {
  font-size: 20px;
}

.tag-container {
	max-height: fit-content !important;
}

.label {
  font-size: 20px;
  font-weight: bold;
}

.lnk_txt {
    margin-left: 42px;
    width: 75%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/app/person/components/PersonDetail.vue